import { computed } from 'vue';
import { useActiveUserStore } from '@/stores/user';
import { useFlag } from '@/composables/useFlag';

export function useAdminSession() {
  const userStore = useActiveUserStore();
  const externalAdminEnabled = useFlag('external-admin');

  const isExternalAdmin = computed(
    () => userStore.isAdmin && externalAdminEnabled.value
  );

  return { isExternalAdmin };
}
